import { BuildAlbumFromApiResponse } from "@helpers/albumFactory";

export default {
    computed: {},
    methods: {
        /**
         * Gets the albums by email.
         * @param email - The email address of the user whose albums will be retrieved.
         * @return The albums associated with the email.
         */
        async getAlbumsByEmail(email = null) {
            try {
                this.$store.dispatch("setLoading", true);
                const emailUser = email || this.$store.state.email;
                const parameters = {
                    type: 3,
                    params: { Email: emailUser },
                };

                /* Calls the API to get the albums by email. */
                const response = await this.$store.dispatch(
                    "getAlbums",
                    parameters
                );
                
                if (!response.length) {
                    this.$store.dispatch("setLoading", false);
                    return;
                }

                // Checks if there are already loaded download codes.
                if (response[0].PhotoExperiences.length) {
                    this.$store.dispatch("deleteDownloadCodesInAlbums");
                }

                /* Calls the `formatAlbumsByEmail` function and passes the API response. */
                this.formatAlbumsByEmail(response);

                /* Shows or hides the loading icon on the screen. */
                this.$store.dispatch("setLoading", false);
                
                /* Checks if the API response contains data. If it does, redirects
                the user to the `albumes` route. */
                if (this.$route.name == "albumes") {
                    Vue.$toast.open({
                        message: this.$t("messages.album_add_successfully"),
                        type: "success",
                    });

                    return;
                }

                this.$router.push({ name: "albumes" });
            } catch (error) {
                this.$store.dispatch("setLoading", false);
            }
        },

        /**
         * Loops through the API response and processes only Download Code albums.
         * If an item has a Type value of 0 and contains photo experiences,
         * it calls `albumsByDownloadCode` with that item.
         * @param data - The data returned from the API call.
         */
        formatAlbumsByEmail(data) {
            data.forEach((item) => {
                // Download Codes
                if (item.PhotoDetails.Type === 0 && item.PhotoExperiences.length) {
                    /* Calls the `albumsByDownloadCode` function and passes the `item` object. */
                    this.albumsByDownloadCode(item);
                }
            });
        },
        /**
         * Builds the album object using the shared factory and stores it in the store.
         * @param data - Item from the API response.
         */
        albumsByDownloadCode(data) {
            const album = BuildAlbumFromApiResponse(data);

            // Stores the album.
            this.$store.dispatch("setAlbum", [album]);
            // Activates the tab to show the codes.
            this.$store.dispatch("setDownloadCodeTab", true);
            this.$store.dispatch("setTypeCodeTab", 0);
        },
    },
};
